import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { BadgeStatisticsClickBiEvent, BiData } from '@wix/da-bi/pkg/events';
import { getDeviationNotificationQueue } from '../../../../DeviationPage/redux/helpers';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { ResourceType } from '../../../../types/resource';
import { getRecipientForDeviation } from '../../../utils';
import CoreBadgeList from '../../CoreBadgeList';

interface Props {
  deviation: PapiDeviation;
  className?: string;
}

const DeviationCoreBadgeList: React.FC<Props> = ({ deviation, className }) => (
  <CoreBadgeList
    className={className}
    badges={deviation.extended?.awardedBadges || []}
    recipient={getRecipientForDeviation(deviation)}
    targetTypeId={ResourceType.DEVIATION}
    targetItemId={deviation.deviationId}
    notificationQueueName={getDeviationNotificationQueue(deviation)}
    biData={BiData<BadgeStatisticsClickBiEvent>({
      evid: 323,
      sectionname: 'deviation',
      typeid: getDeviationResourceType(deviation),
      itemid: deviation.deviationId,
    })}
  />
);
DeviationCoreBadgeList.displayName = 'DeviationCoreBadgeList';

export default DeviationCoreBadgeList;
